import { HIGHEST_PREMIUM_DISCOUNT, HIGHEST_PREMIUM_DISCOUNT_STREAM, PREMIUM_DISCOUNT_LAST_UPDATED_TIME, } from "../../../interface/DrivingMarket/iHighestPremiumDiscount";
import { drivingMarketStream } from "@domains/features/Markets/Futures/utils/streamingUpdate";
let initState = {
    highestPremiumDiscountData: [],
    latestUpdatedTime: "",
};
const highestPremiumDiscountReducer = (state = initState, action) => {
    var _a;
    switch (action.type) {
        case HIGHEST_PREMIUM_DISCOUNT:
            return Object.assign(Object.assign({}, state), { highestPremiumDiscountData: action.payload.highestPremiumDiscountData });
        case HIGHEST_PREMIUM_DISCOUNT_STREAM:
            return Object.assign(Object.assign({}, state), { highestPremiumDiscountData: drivingMarketStream(state.highestPremiumDiscountData, action.payload.qouteStream), latestUpdatedTime: (_a = action.payload.qouteStream) === null || _a === void 0 ? void 0 : _a.updatedTime });
        case PREMIUM_DISCOUNT_LAST_UPDATED_TIME:
            return Object.assign(Object.assign({}, state), { latestUpdatedTime: action.payload.latestUpdatedTime });
        default:
            return state;
    }
};
export default highestPremiumDiscountReducer;
